
    <ng-container *transloco="let t">

    <c-row *ngIf="formGroup">
        <c-col md="12">
            <h1>{{ t('Update your Credit Card Details') }}</h1>
            <p>
            {{ t('If your credit card details have changed or your payments have failed, please update your details here:') }}
            </p>
            <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">
            <div class="row">
              <div class="col-12 col-lg-6">
  
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Card Name') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'card_name'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['card_name'].errors }"
                    />
                    <div *ngIf="submitted && f['card_name'].errors" class="invalid-feedback">
                      <br/>{{ t('Card Name') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
  
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Card Number') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'card_number'"
                      cFormControl
                      placeholder="0000 0000 0000 0000"
                      [ngClass]="{ 'border-danger': submitted && f['card_number'].errors }"
                    />
                    <div *ngIf="submitted && f['card_number'].errors" class="invalid-feedback">
                      <br/>{{ t('Card Number') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Expiry Month') }}</label>
                  <div class="col-8">
                    <ng-select
                    [items]="months"
                    bindLabel="lab"
                    bindValue="val"
                    formControlName="card_month"
                  >
                  </ng-select>
                    <div *ngIf="submitted && f['card_month'].errors" class="invalid-feedback">
                      <br/>{{ t('Expiry Month') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Expiry Year') }}</label>
                  <div class="col-8">
                    <ng-select
                    [items]="years"
                    bindLabel="lab"
                    bindValue="val"
                    formControlName="card_year"
                  >
                  </ng-select>
                    <div *ngIf="submitted && f['card_year'].errors" class="invalid-feedback">
                      <br/>{{ t('Expiry Year') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('CVV/CVC') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'card_cvv'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['card_cvv'].errors }"
                    />
                    <div *ngIf="submitted && f['card_cvv'].errors" class="invalid-feedback">
                      <br/>{{ t('CVV/CVC') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
                <p>
                  <i class="fas fa-info-circle text-info"></i> {{ t('We only accept Visa or Mastercard.') }} <img src="./assets/images/card-mastercard.png" height="33px" width="46px">  <img src="./assets/images/card-visa.png" height="33px" width="46px"> <br/> 
                  {{ t('If you cannot pay by these methods, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>
                </p>
  
  
              </div>
  
              <div class="col-12 col-lg-6">
  
  
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Address') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'address1'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['address1'].errors }"
                    />
                    <div *ngIf="submitted && f['address1'].errors" class="invalid-feedback">
                      <br/>{{ t('Address') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('City') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'city'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['city'].errors }"
                    />
                    <div *ngIf="submitted && f['city'].errors" class="invalid-feedback">
                      <br/>{{ t('City') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
  
                <div class="form-group row mb-2"  *ngIf="formGroup.value.country == 'CA'">
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Province') }}</label>
                  <div class="col-8">
                    <ng-select [items]="canadian_states"
                    bindLabel="name"
                    bindValue="code"
                    formControlName="state"
                    placeholder="{{ t('State') }}"
                    [ngClass]="{ 'border-danger': submitted && f['state'].errors }">
                  </ng-select>
                  <div *ngIf="submitted && f['state'].errors" class="invalid-feedback">
                    <br/>{{ t('Country') }} {{ t('is required') }}
                  </div>
                  </div>
                </div>
  
                <div class="form-group row mb-2" *ngIf="formGroup.value.country != 'CA'">
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('State/County') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'state'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['state'].errors }"
                    />
                    <div *ngIf="submitted && f['state'].errors" class="invalid-feedback">
                      <br/>{{ t('State/County') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
  
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Postcode/Zip') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'postcode'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['postcode'].errors }"
                    />
                    <div *ngIf="submitted && f['postcode'].errors" class="invalid-feedback">
                      <br/>{{ t('Postcode/Zip') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
  
  
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Country') }}</label>
                  <div class="col-8">
                    <ng-select [items]="countries"
                    bindLabel="name"
                    bindValue="code"
                    formControlName="country"
                    placeholder="{{ t('Country') }}"
                    [ngClass]="{ 'border-danger': submitted && f['country'].errors }">
                  </ng-select>
                  <div *ngIf="submitted && f['country'].errors" class="invalid-feedback">
                    <br/>{{ t('Country') }} {{ t('is required') }}
                  </div>
                  </div>
                </div>
  
                
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Email') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'email'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['email'].errors }"
                    />
                    <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                      <br/>{{ t('Email') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
                
                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end">{{ t('Phone') }}</label>
                  <div class="col-8">
                    <input
                      [formControlName]="'phone'"
                      cFormControl
                      placeholder=""
                      [ngClass]="{ 'border-danger': submitted && f['phone'].errors }"
                    />
                    <div *ngIf="submitted && f['phone'].errors" class="invalid-feedback">
                      <br/>{{ t('Phone') }} {{ t('is required') }}
                    </div>
                  </div>
                </div>
  
              </div>
  
            </div>

            <div>
              I agree to the <a href="https://www.okaloneworker.com/work-alone-monitoring-terms/" target="_new">Terms and Conditions</a> and <a href="https://www.okaloneworker.com/work-alone-monitoring-privacy/" target="_new">Privacy Policy</a>.<br/>

              <input type="checkbox" class="form-check-input" formControlName="agree_terms" name="agree_terms">
              <label class="form-check-label" for="agree_terms">&nbsp;&nbsp;&nbsp;Check this box to confirm your agreement.</label><br/><br/>
            </div>
  
              <div *ngIf="card_notice" class="alert" [class.alert-warning]="!card_notice.success"  [class.alert-success]="card_notice.success"  role="alert">
                {{card_notice.message}}
              </div>
  
              <button cButton class="px-4 text-white btn-info" type="submit" [disabled]="!formGroup.value.agree_terms || processing">
                <i class="fa-regular fa-credit-card"></i> {{ t('Submit your Credit Card Details') }}
              </button>
  
          </form>
          </c-col>
        </c-row>
    </ng-container>